import EventsCalendarController from './controller'
import { SCHEDULE_TABS } from './types'
import { EventsCalendarView } from './view'

export type Event = {
  dateStart: string
  dateEnd: string | null
  description: string
  id: string
  situation: string
  type: string
  organs: {
    initials: string
  }[]
}

type EventsCalendarProps = {
  events: Event[]
  headerLocation: string
  handleUpdateSearch: (data: Record<string, string>) => void
  selectedDate?: Date
  setSelectedDate?: (date: Date) => void
  tab?: SCHEDULE_TABS
  setTab?: (value: SCHEDULE_TABS) => void
  hideOptionList?: boolean
}

export function EventsCalendar({
  events,
  headerLocation,
  handleUpdateSearch,
  selectedDate,
  setSelectedDate,
  tab,
  setTab,
  hideOptionList,
}: EventsCalendarProps) {
  return (
    <EventsCalendarController>
      <EventsCalendarView
        events={events}
        headerLocation={headerLocation}
        handleUpdateSearch={handleUpdateSearch}
        selectedDate={selectedDate}
        setSelectedDate={setSelectedDate}
        tab={tab}
        setTab={setTab}
        hideOptionList={hideOptionList}
      />
    </EventsCalendarController>
  )
}
